<template>
    <table id="songs">
        <thead>
            <tr>
                <th></th>
                <th>Name</th>
                <th v-if="middle !== 'NA'">{{ middle | capitalize }}</th>
                <th>Popularity</th>
                <th></th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="row in visibleRows" :key="row.name" @click="play(row)">
                <td><img :src="row.image" /></td>
                <td>{{ row.name }}</td>
                <td v-if="middle !== 'NA'">{{ concat(row[middle]) }}</td>
                <td>{{ row.popularity }}</td>
                <td>
                    <span class="icon">
                        <i class="fas fa-play"></i>
                    </span>
                </td>
            </tr>
            <tr class="toggle-all" @click="showAll = !showAll">
                <td :colspan="middle !== 'NA' ? 5 : 4">
                    {{ showAll ? "Hide all" : "Show all" }}
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
/*
    Takes a list of rows to develop. The prop 'middle' is the attribute to show in the middle column, for example genres
    or artists
     */
export default {
    name: "TrackArtistTableWidget",
    props: ["rows", "middle"],
    data() {
        return {
            showAll: false
        };
    },
    methods: {
        concat(artists) {
            return artists.join(", ");
        },
        play(row) {
            this.$store.commit("play", row.uri);
        }
    },
    filters: {
        capitalize: function(value) {
            if (!value) return "";
            value = value.toString();
            return value.charAt(0).toUpperCase() + value.slice(1);
        }
    },
    computed: {
        visibleRows() {
            if (this.showAll) {
                return this.rows;
            } else {
                return this.rows.slice(0, 3);
            }
        }
    }
};
</script>

<style scoped lang="scss">
.toggle-all {
    cursor: pointer;
    text-align: center;
    font-weight: bold;
    font-size: 1.5em;
    td {
        padding: 10px;
    }
}
table {
    table-layout: auto;
    width: 100%;
    border-collapse: collapse;
}
table {
    td {
        vertical-align: middle;
        cursor: pointer;
    }
}

td:nth-child(1) {
    width: 80px;
    min-width: 80px;
}

img {
    height: 80px;
    width: 80px;
    object-fit: contain;
}

thead th {
    background-color: rgba(23, 173, 55, 0.4);
    /*background: linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(233,52,71,0.9082983535210959) 0%, rgba(12,87,24,1) 0%, rgba(38,248,4,1) 100%);
  text-shadow: 1px 1px 1px white;*/
    color: white;
    font-weight: bold;
    font-size: 1.2em;
}

th,
td {
    padding: 5px 20px;
}

tbody tr:nth-child(odd) {
    background-color: #1278282b;
}

tbody tr:nth-child(even) {
    background-color: #17ad372b;
}
</style>
